import NormativeGraph from "./components/NormativeGraph";
import NormativeGraphTable from "./components/NormativeGraphTable";

export {NormativeGraphTable}

export default NormativeGraph